// GP-style color palette for charts
export const CHART_COLORS = {
  orange: '#f97316',
  blue: '#3b82f6',
  emerald: '#10b981',
  purple: '#8b5cf6',
  cyan: '#06b6d4',
  amber: '#f59e0b',
  rose: '#f43f5e',
};
